import { cn } from "@btnet/utilities-core";

import {
    BdsButton,
    BdsIconHomeowners,
    BdsIconPlus,
    BdsIconSubsVendors,
} from "@buildertrend/components";

import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";
import "commonComponents/entity/media/MediaViewingPermissionReadonly/MediaViewingPermissionReadonly.less";

export interface IMediaViewingPermissionReadonlyProps {
    showClient: boolean;
    showSubs: boolean;
    showAllSubs?: boolean;
    entityId: number;
    entityType: "folder" | "file";
    justify?: "start" | "end" | "center" | "space-around" | "space-between";
    noWrap?: boolean;
    className?: string;
    canSetPermissions?: boolean;
    showCanAdd?: boolean;
    onEditPermissionsClick?: (id: number) => void;
}

function MediaViewingPermissionReadonly({
    showClient,
    showSubs,
    showAllSubs = true,
    justify = "center",
    noWrap = false,
    className,
    canSetPermissions,
    entityId,
    entityType,
    showCanAdd,
    onEditPermissionsClick,
}: IMediaViewingPermissionReadonlyProps) {
    const subsText = showAllSubs ? "Subs/trades can view" : "Some subs/trades can view";
    const clientsText = "Client can view";

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (onEditPermissionsClick) {
            onEditPermissionsClick(entityId);
        }
    };

    const subButton = (
        <BdsButton
            // Using a non-clickable BdsButton since we shouldn't use a BTPopover on a span or div due to accessibility
            icon={<BdsIconSubsVendors />}
            ariaLabel="Set subs/vendors permissions"
            className="MediaViewingPermissionsReadonly-icon"
            testid={`${entityType}-permissions-subs-${entityId}`}
            onClick={canSetPermissions ? handleClick : undefined}
            displayType="tertiary"
            disabled={!canSetPermissions}
            tooltip={subsText}
            tooltipStyle={{ whiteSpace: "nowrap" }}
            style={{ marginRight: 0 }}
        />
    );

    const clientButton = (
        <BdsButton
            // Using a non-clickable BdsButton since we shouldn't use a BTPopover on a span or div due to accessibility
            icon={<BdsIconHomeowners />}
            ariaLabel="Set client permissions"
            className="MediaViewingPermissionsReadonly-icon"
            testid={`${entityType}-permissions-clients-${entityId}`}
            onClick={canSetPermissions ? handleClick : undefined}
            displayType="tertiary"
            disabled={!canSetPermissions}
            tooltip={clientsText}
            style={{ marginRight: 4 }}
        />
    );

    return (
        <BTRow
            className={cn(className, "MediaViewingPermissionsReadonly", {
                "MediaViewingPermissionsReadonly-nowrap": noWrap,
            })}
            gutter={8}
            align="middle"
            justify={justify}
        >
            {showSubs && subButton}
            {showClient && clientButton}
            {!showSubs && !showClient && showCanAdd && canSetPermissions && (
                <BdsButton
                    icon={<BdsIconPlus />}
                    onClick={handleClick}
                    tooltip="Add permissions"
                    testid={`add-${entityType}-permissions-${entityId}`}
                    disabled={!canSetPermissions}
                    text="Add"
                    displayType="tertiary"
                />
            )}
        </BTRow>
    );
}

export default MediaViewingPermissionReadonly;
